import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

import { AdminLayout } from "@/components/admin/layout/AdminLayout";
import { useAdminAuth } from "@/hooks/useAdminAuth";
import { PostForm } from "@/components/admin/blog/PostForm";
import { blogAdminService, BlogPostFormData } from "@/services/blogAdminService";
import { Button } from "@/components/ui/button";

export default function NewPost() {
  const navigate = useNavigate();
  const { isAdmin, loading: authLoading } = useAdminAuth();

  useEffect(() => {
    if (!authLoading && !isAdmin) {
      navigate("/admin-login");
    }
  }, [authLoading, isAdmin, navigate]);

  async function handleSubmit(data: BlogPostFormData, published: boolean) {
    try {
      await blogAdminService.createPost({ ...data, published });
      toast.success("Post criado com sucesso!");
      navigate("/admin/posts");
    } catch (error: any) {
      toast.error(error.message || "Erro ao criar post");
      throw error;
    }
  }

  if (authLoading || !isAdmin) {
    return null;
  }

  return (
    <AdminLayout
      title="Novo conteúdo"
      description="Transforme histórias Toc Toc em artigos completos, com imagens, SEO e distribuição automática."
      breadcrumbs={[
        { label: "Admin", href: "/admin" },
        { label: "Blog", href: "/admin/posts" },
        { label: "Novo" },
      ]}
      actions={
        <Button variant="outline" asChild>
          <Link to="/admin/posts">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Voltar para lista
          </Link>
        </Button>
      }
    >
      <section className="mx-auto max-w-5xl">
        <PostForm onSubmit={handleSubmit} />
      </section>
    </AdminLayout>
  );
}
